import { useCallback } from 'react';
import { useDemoMode } from '@/context/DemoModeContext';

/**
 * Hook to add demo prefix to paths when in demo mode
 * @returns withDemoPrefix function that transforms paths
 */
const useDemoPath = () => {
  const { isDemoMode } = useDemoMode();

  const withDemoPrefix = useCallback(
    (href: string) => {
      if (isDemoMode && href.startsWith('/dashboard')) {
        return `/demo${href}`;
      }
      return href;
    },
    [isDemoMode]
  );

  return { withDemoPrefix, isDemoMode };
};

export default useDemoPath;
